/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShipmentCreateDto } from '../../models/shipment-create-dto';
import { ShipmentDto } from '../../models/shipment-dto';

export interface ShipmentControllerCreate$Params {
      body: ShipmentCreateDto
}

export function shipmentControllerCreate(http: HttpClient, rootUrl: string, params: ShipmentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipmentDto>> {
  const rb = new RequestBuilder(rootUrl, shipmentControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShipmentDto>;
    })
  );
}

shipmentControllerCreate.PATH = '/api/shipments';
